// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__1ewfD","modal":"Modal_modal__3MLaR","slide-down":"Modal_slide-down__aHaky"};